export const SESSION_KEY_SAVE: string = 'save';
export const SESSION_KEY_CSRF: string = 'csrf';
